import { combineReducers } from 'redux';

import byId from './byId';
import errorWhileDeleting from './errorWhileDeleting';
import errorWhileListFetching from './errorWhileListFetching';
import isDeleting from './isDeleting';
import isFetched from './isFetched';
import isListFetching from './isListFetching';
import items from './items';
import limit from './limit';
import memberId from './memberId';
import offset from './offset';
import searchKeyword from './searchKeyword';
import totalCount from './totalCount';

export default combineReducers({
  byId,
  limit,
  errorWhileDeleting,
  errorWhileListFetching,
  isDeleting,
  isFetched,
  isListFetching,
  items,
  memberId,
  offset,
  searchKeyword,
  totalCount,
});
